import { render, staticRenderFns } from "./buildList1.vue?vue&type=template&id=22d6a908&scoped=true"
import script from "./buildList1.vue?vue&type=script&lang=js"
export * from "./buildList1.vue?vue&type=script&lang=js"
import style0 from "./buildList1.vue?vue&type=style&index=0&id=22d6a908&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6a908",
  null
  
)

export default component.exports